export const GetBanks = async (apiBaseUrl: string | undefined) => {
    return await fetch(`${apiBaseUrl}quote/GetBanks`)
        .then(response => {
            return response.json();
        })
        .then(data => {
            if (!data.success) {
                return [{ text: "", value: "" }];;
            }
            const banksList = JSON.parse(data.object)
            const banks = banksList.map((bank: any) => ({
                value: bank.bankNameId,
                text: bank.bankNameDebug
            }))
            return [
                { value: "", text: "" },
                ...banks
            ]
        })
}